import DashboardWidget from "../DashboardWidget";
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import { useEffect, useState } from "react";
import dashboardServicev2 from "../../service/DashboardServicev2";
import WidgetPeriodSelection from "./WidgetPeriodSelection";
import { useHistory } from "react-router-dom";
import batchParameterv2 from "../../service/BatchParameterv2";
import { useTranslation } from "react-i18next";
import MahsupTipi from "../../enum/MahsupTipi";

const MahsuplarWidget = () => {

    const { t } = useTranslation();
    const [periodId, setPeriodId] = useState(null)
    const [tutar, setTutar] = useState(0)

    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const _periodId = await batchParameterv2.getDonem();
                setLoading(false);
                setPeriodId(_periodId);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }

        })();
    }, []);


    const onClick = (type) => {
        history.push(`/eviziteMahsup?type=${type}&periodId=${periodId}`)
    };

    const getTotal = (type) => {
        if (tutar) {
            const value = tutar.filter(r => r.durum == type).map(r => r.totalTutar);
            return value == 0 ? null : value;
        }
        return null;
    }

    useEffect(() => {
        if (periodId) {
            (async () => {
                try {
                    setLoading(true);
                    const _tutar = await dashboardServicev2.viziteMahsup({ periodId });

                    setTutar(_tutar);
                } catch (e) {
                    console.error(e)
                } finally {
                    setLoading(false);
                }
            })();
        }
    }, [periodId])

    const StatisticDisplay = ({ label, value }) => {
        return (
            <div style={{ marginTop: "10px" }}>
                <div style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "16px", lineHeight: "24px" }}>
                    {label}
                </div>
                <div style={{ color: "#987EFF", fontSize: "34px", lineHeight: "36px" }}>
                    ₺{value ? new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2 }).format(value) : "   -   "}
                </div>
            </div>
        );
    }

    return (
        <DashboardWidget loading={loading} height={140 * 2.112}>
            <div style={{ padding: "0 24px", width: "100%", position: "relative" }}>

                <WidgetPeriodSelection periodId={periodId} setPeriodId={setPeriodId} />


                <table style={{ width: "100%" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "rgba(0, 0, 0, 0.38)" }}>

                                <div style={{
                                    color: "rgba(0, 0, 0, 0.38)",
                                    fontSize: "12px",
                                    lineHeight: "20px"
                                }}>
                                    {periodId} Dönem
                                </div>
                                <div style={{ cursor: "pointer" }} onClick={() => onClick(2)}>
                                    <StatisticDisplay label={t('Widget.odemeEmrine')} value={getTotal(2)} />
                                </div>
                                <div style={{ cursor: "pointer" }} onClick={() => onClick(3)}>
                                    <StatisticDisplay label={t('Widget.kurumEmanetine')} value={getTotal(3)} />
                                </div>
                                <div style={{ cursor: "pointer" }} onClick={() => onClick(5)}>
                                    <StatisticDisplay label={t('Widget.mahsupTamamlandi')} value={getTotal(5)} />
                                </div>
                            </td>
                            <td style={{ width: 175 }}>
                                <div style={{
                                    fontSize: 28, lineHeight: "24px", marginBottom: 24, color: "#7959FB"
                                }}>Mahsuplaştırma</div>
                                < div style={{
                                    width: "73px",
                                    height: "73px",
                                    background: "#DDD5FF",
                                    borderRadius: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}>
                                    <PaymentsOutlinedIcon sx={{ color: "#6143D8", fontSize: "38px" }} />

                                </div>

                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </DashboardWidget >
    )

}

export default MahsuplarWidget;
